import { contentActions } from './content';
import { publishedEventActions } from './published-event';
import { publisherActions } from './publisher';

const actions = {
  publisherPortal: {
    ...contentActions.publisherPortal,
    ...publishedEventActions.publisherPortal,
    ...publisherActions.publisherPortal,
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/actions.js